import { BsBuilding } from "react-icons/bs";
import { HiOutlineExclamationCircle } from "react-icons/hi";
import { SguUnitsSideMenu, SguUnitMenuItem } from "../../../components/SguUnitsMenu";

const textoLimitado = (texto, limite = 30) => {
  if (!texto) return "";
  return texto.length <= limite ? texto : `${texto.slice(0, limite)}...`;
};

const getRodzCount = (unit) => {
  const arr = Array.isArray(unit?.otherEquipments) ? unit.otherEquipments : [];
  return arr.filter((e) => e.serialNumber?.toUpperCase().includes("RODZ")).length;
};

const RotationMenu = ({
  user,
  units,
  onUnitSelect,
  onSearch,
  selectedUnit,
  searchValue,
  headerRight,
}) => (
  <SguUnitsSideMenu
    icon={BsBuilding}
    subtitle="Seleção"
    title="Unidades"
    headerRight={headerRight}
    sectionId="rotation-unidades"
    searchValue={searchValue}
    onSearch={onSearch}
    emptyText="Nenhuma unidade com rodízio encontrada"
  >
    {(units || []).map((unit) => {
      const rodzCount = getRodzCount(unit);
      return (
        <SguUnitMenuItem
          key={unit._id || unit.cnpj}
          active={selectedUnit?._id === unit._id}
          title={
            user?.hideSensitiveInfo
              ? "*****"
              : textoLimitado(unit.name?.toUpperCase() || "Empresa sem nome", 30)
          }
          badge={
            <>
              <HiOutlineExclamationCircle size={12} className="me-1" />
              {rodzCount} {rodzCount === 1 ? "rodízio" : "rodízios"}
            </>
          }
          meta={user?.hideSensitiveInfo ? "*****" : unit?.address || "--"}
          onClick={() => onUnitSelect(unit)}
        />
      );
    })}
  </SguUnitsSideMenu>
);

export default RotationMenu;
